import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import type { Observable } from 'rxjs';
import { MobileMenuService } from '../../../core/services/mobile-menu.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { LeftMenuComponent } from '../left-menu/left-menu.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    LeftMenuComponent,
    FooterComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  private mobileMenuService = inject(MobileMenuService);

  mobileMenuOpen$: Observable<boolean> = this.mobileMenuService.mobileMenuOpen$;

  closeMobileMenu(): void {
    this.mobileMenuService.closeMobileMenu();
  }
}
